import { useEffect, useState } from "react";

export const useSortableTable = data => {
  const [tableData, setTableData] = useState(data);

  useEffect(
    () => {
      setTableData(data);
    },
    [data]
  );

  const handleSorting = (sortCol, sortOrder) => {
    if (sortCol) {
      const sorted = [...tableData].sort((a, b) => {
        if (a[sortCol] === null) return 1;
        if (b[sortCol] === null) return -1;
        if (a[sortCol] && b[sortCol] == null) return 0;
        return (
          a[sortCol].toString().localeCompare(b[sortCol].toString(), "en", {
            numeric: true
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      setTableData(sorted);
    }
  };

  const delRow = idx => {
    const copyTable = [...tableData];
    copyTable[idx]["isCaught"] = !copyTable[idx]["isCaught"];
    setTableData(copyTable);
  };
  return [tableData, handleSorting, delRow, setTableData];
};
